import { ContentLookup, X1Language, X2AgeCategory, X3Level, X4Unit, X5Lesson } from '../../domain';
import { routes } from '../../pages/Routes';
import { NodeData } from './menu/models/node-data';

const R = routes;
const userManagementItems: NodeData[] = [
  {
    icon: 'fas fa-user-friends',
    label: 'List users',
    route: R.UserList
  },
  {
    icon: 'fas fa-user-plus',
    label: 'Add user',
    route: R.UserAdd
  },
  {
    icon: 'fas fa-user-friends',
    label: 'List registrations',
    route: R.RegistrationList
  }
];

const systemSettingsItems: NodeData[] = [
  {
    icon: 'fas fa-clock',
    label: 'Time Zones',
    route: R.TimeZoneList
  }
];

const classroomManagementItems: NodeData[] = [
  {
    icon: 'fas fa-chalkboard-teacher',
    label: 'Classrooms',
    route: R.AdminClassrooms
  },
];

const studentMenu: NodeData[] = [
  {
    icon: 'far fa-calendar-alt',
    label: 'sidebar.schedule',
    route: R.StudentSchedule
  },
  {
    icon: 'fas fa-home',
    label: 'sidebar.homework',
    route: R.StudentHomeworkList
  },
  {
    icon: 'far fa-keyboard',
    label: 'sidebar.essays',
    route: R.EssayStudentList
  },
  {
    icon: 'far fa-calendar-alt',
    label: 'sidebar.exams',
    route: R.ExamStudentList
  }
];

const teacherMenu: NodeData[] = [
  {
    icon: 'fas fa-users',
    label: 'My students',
    route: R.TeacherStudents
  },
  {
    icon: 'far fa-calendar-alt',
    label: 'Schedule',
    route: R.TeacherSchedule
  },
  {
    icon: 'far fa-calendar-alt',
    label: 'Working days',
    route: R.TeacherWorkDays
  },
  {
    icon: 'fas fa-chalkboard-teacher',
    label: 'Lessons',
    route: R.TeacherLessons
  },
  {
    icon: 'far fa-calendar-alt',
    label: 'Essays',
    route: R.EssayTeacherList
  },
  // {
  //   icon: 'far fa-keyboard',
  //   label: 'Exams',
  //   route: R.ExamTeacherList
  // }
];

/******************************************************************************/

function isNonEmptyArray<T>(value: readonly T[] | null | undefined): value is T[] {
  return Array.isArray(value) && value.length > 0;
}

function mapX5(lesson: X5Lesson): NodeData {
  return {
    icon: 'fas fa-book-reader',
    label: lesson.Name,
    route: R.x5lesson(lesson.Id)
  };
}

function mapX4(unit: X4Unit): NodeData {
  let result: NodeData = {
    icon: 'fas fa-book-open',
    label: unit.Name,
    route: R.x4unit(unit.Id)
  };
  if (isNonEmptyArray(unit.Lessons))
    result.children = unit.Lessons.map(mapX5);
  return result;
}

function mapX3(level: X3Level): NodeData {
  let result: NodeData = {
    icon: 'fas fa-atlas',
    label: level.Name,
    route: R.x3level(level.Id)
  };
  if (isNonEmptyArray(level.Units))
    result.children = level.Units.map(mapX4);
  return result;
}

function ageCategoryIcon(name: string) {
  switch (name.toLowerCase()) {
    case 'children':
      return 'fas fa-baby';
    case 'teen':
      return 'fas fa-child';
    case 'adult':
      return 'fas fa-male';
    default:
      return 'fas fa-plus';
  }
}

function mapX2(ageCategory: X2AgeCategory): NodeData {
  let result: NodeData = {
    icon: ageCategoryIcon(ageCategory.Name),
    label: ageCategory.Name,
    route: R.x2ageCategory(ageCategory.Id)
  };
  if (isNonEmptyArray(ageCategory.Levels))
    result.children = ageCategory.Levels.map(mapX3);
  return result;
}

function mapX1(language: X1Language): NodeData {
  let result: NodeData = {
    icon: 'fas fa-flag',
    label: language.Name,
    route: R.x1language(language.Id)
  };
  if (isNonEmptyArray(language.AgeCategories))
    result.children = language.AgeCategories.map(mapX2);
  return result;
}

let languageList: NodeData =
{
  icon: 'fas fa-globe',
  label: 'Language List',
  route: R.X1LanguageList
}
  ;

function prepareContentManagementItems(lookup: ContentLookup): NodeData[] {
  return [languageList].concat(lookup.Languages.map(mapX1));
}

/******************************************************************************/

class SidebarHelperClass {
  readonly systemSettingsItems = systemSettingsItems;
  readonly userManagementItems = userManagementItems;
  readonly classroomManagementItems = classroomManagementItems;
  readonly studentItems = studentMenu;
  readonly teacherItems = teacherMenu;
  readonly prepareContentManagementItems = prepareContentManagementItems;
}

export const SidebarHelper = new SidebarHelperClass();
